export const GENERAL_PURCHASE_OUTSTANDING_REPORT_REQUEST = 'GENERAL_PURCHASE_OUTSTANDING_REPORT_REQUEST';
export const GENERAL_PURCHASE_OUTSTANDING_REPORT_SUCCESS = 'GENERAL_PURCHASE_OUTSTANDING_REPORT_SUCCESS';
export const GENERAL_PURCHASE_OUTSTANDING_REPORT_FAILURE = 'GENERAL_PURCHASE_OUTSTANDING_REPORT_FAILURE';